import React from "react";
import RevokeCookies from "./RevokeCookies";
import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import { Paragraph, H4 } from "BaseComponents/Text";

export const CookieBlock = ({
	Category,
	CookieName,
	Description,
	Expire,
	Owner,
	first,
	ExpiresLabel,
	OwnerLabel,
	CategoryLabel,
	ChangeSettingsLabel,
}) => {
	return (
		<CookieWrapper>
			{first && <RevokeCookies settingsLabel={ChangeSettingsLabel} />}
			<CookieBlockWrapper>
				<CookieBlockTitleWrapper>
					<CookieBlockTitle black>{CookieName}</CookieBlockTitle>
				</CookieBlockTitleWrapper>
				{Description !== null && Description.length > 0 && (
					<CookieDescription>{Description}</CookieDescription>
				)}
				<CookieBlockList>
					<CookieBlockListItem flex>
						<CookieListHeader>{ExpiresLabel}:</CookieListHeader>
						<CookieListValue nomargin>{Expire}</CookieListValue>
					</CookieBlockListItem>
					<CookieBlockListItem flex>
						<CookieListHeader>{OwnerLabel}:</CookieListHeader>
						<CookieListValue nomargin>{Owner}</CookieListValue>
					</CookieBlockListItem>
					<CookieBlockListItem flex>
						<CookieListHeader>{CategoryLabel}:</CookieListHeader>
						<CookieListValue nomargin>{Category}</CookieListValue>
					</CookieBlockListItem>
				</CookieBlockList>
			</CookieBlockWrapper>
		</CookieWrapper>
	);
};
const CookieWrapper = styled.div``;
const CookieBlockWrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.gray};
	font-family: ${({ theme }) => theme.font};
	border-radius: 5px;
	border: solid 1px #949494;
	margin: 0.5rem 0;
`;
const CookieBlockTitleWrapper = styled.div`
	border-bottom: ${`2px solid ${({ theme }) => theme.colors.primary}`};
	padding: 1rem;
`;
const CookieBlockTitle = styled(H4)`
	margin: 0;
`;
const CookieListHeader = styled(Paragraph)`
	flex-basis: 30%;
	font-weight: bold;
	margin: 0 0.5rem 0 0;
	position: relative;

	${media.greaterThan(breakpoints.ipad)`
        min-width: 100px;
        max-width: 100px;
        &:after {
            left: 0;
            width: 2px;
            height: 100%;
            top: 0;
        }
    `};
`;
const CookieListValue = styled(Paragraph)`
	margin: 0;
`;
const CookieDescription = styled(Paragraph)`
	margin: 0;
	padding: 1rem 1rem 0 1rem;
	max-width: 500px;
`;
const CookieBlockList = styled.ul`
	padding: 0.8rem 1rem;
	display: flex;
	justify-content: flex-start;
	list-style: none;
	${media.greaterThan(breakpoints.ipad)`
      flex-direction: column;
  `};
`;
const CookieBlockListItem = styled.li`
	flex-direction: row;
	margin-left: 2rem;
	&:first-of-type {
		margin-left: 0;
	}
	&:before {
		content: none;
	}
	${media.greaterThan(breakpoints.ipad)`
      margin-left: 0;
  `};
`;
